/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('videoEmbed', ['$sce', 'VideoEmbedService', function ($sce) {
    return {
      templateUrl: "modules/common/directives/embeds/video-embed-directive.html",
      replace: true,
      scope: true,
      /**
       *
       * @param attrs.videoSrc string - The actual url link to the video
       * @params attrs.service {string} - The service provider for the video (i.e. youtube, kaltura, etc)
       * @params attrs.height {string} - The height to be applied to the iFrame element
       * @params attrs.width {string} - The width to be applied to the iFrame element
       */
      link: function link(scope, elem, attrs) {
        var service = attrs.service,
          videoSrc = attrs.videoSrc,
          height = attrs.height,
          width = attrs.width;

        // Set some defaults (can't use ES6 defaults, because it's not a truthy/falsy check, it actually checks for undefined)
        service = service || 'unknown';
        height = height || 315;
        width = width || 560;

        // This is just a UI element, if we can't compile a video, we want to display
        // which token was failing so the user can investigate it.
        scope.token = "{{video:".concat(videoSrc, "}}");
        if (service === 'unknown') {
          scope.src = '';
        } else {
          scope.src = $sce.trustAsResourceUrl(videoSrc);
          scope.height = height;
          scope.width = width;
        }
      }
    };
  }])

  /**
   * This light factory just provide a consolidated place to manage
   * the valid video service supported by our video embed directive
   */.factory('VideoEmbedService', [function () {
    // Capture group at index 2 is the url source that should be used
    // for the videos. The capture groups at 0 and 3 allow for conditional
    // spaces before and after the "video:" string and after the capture
    // group 1 string.
    var VIDEO_TOKEN_PATTERN = /{{(\s*?)?video:(.*?)(\s*?)?}}/;

    // This map of valid video service includes patterns for matching
    // the urls of our whitelisted services. If a url doesn't match any
    // of these services, a warning will be displayed to the user.
    // Note: We use the keys as display names, so enter the key the way it
    // should display in the help text, complete with proper capitalization.
    var validVideoServices = {
      'YouTube': ['https://(www\.)?youtube.com/embed/.*'],
      'Kaltura': ['https://(www\.)?.*?.?kaltura.com/.*'],
      'Instilled': ['https://(www\.)?.*?.?kzoplatform.com/.*'],
      'Widen Collective': ['https://(www\.)?embed.widencdn.net/.*'],
      'EduTube': ['https://(www\.)?edutube.emc.com/.*'],
      'Watershed': ['https://(www\.)?watershedlrs.com/.*', 'https://(www\.)?watershedlrs.eu/.*']
    };
    var self = {
      /**
       * This function returns the video service provider for a given url.
       *
       * @param videoSrcUrl string - The url to check
       * @returns {string} - The service provider matching the videoSrcUrl OR 'unknown' if no matches found
       */
      getVideoService: function getVideoService(videoSrcUrl) {
        var serviceMatch = 'unknown';

        // Pulled out map func to avoid jshint error
        var urlMatchesValidService = function urlMatchesValidService(url) {
          return videoSrcUrl.match(url);
        };
        for (var _i = 0, _Object$keys = Object.keys(validVideoServices); _i < _Object$keys.length; _i++) {
          var service = _Object$keys[_i];
          var validServicePatterns = validVideoServices[service];
          var matchesService = validServicePatterns.map(urlMatchesValidService).filter(Boolean) // Remove falsy values
          .reduce(function (curr, acc) {
            return acc ? acc : !!curr;
          }, false); // Reduce down to only a true or false value
          if (matchesService) {
            serviceMatch = service;
            break;
          }
        }
        return serviceMatch;
      },
      /**
       * Get the dimensionType if it was passed in the token
       *
       * @param dimensionType string - Can be 'height' or 'width'
       * @param token string - The video embed token. It doesn't have to have the dimensionType properties,
       *                       we'll do safety checks within the function.
       *                       i.e. "{{video:http://youtu.be/teststring, width: 500, height: 350}}" OR
       *                            "{{ video:http://youtu.be/teststring }}"
       * @returns {string}
       */
      getDimension: function getDimension(dimensionType, token) {
        var matches = token.replace(/[{}]/g, '').split(',').map(function (s) {
          return s.trim();
        })
        // Note we're making a conscious decision to NOT try to parse height/width
        // from URL query params at the moment, but if we change that, this filter
        // will probably need to be updated.
        .filter(function (s) {
          return s.includes(dimensionType + ':');
        });
        if (matches.length > 0) {
          var string = matches[0];
          // Match <dimensionType>: (500)
          return string.match(/\D*(\d*)/)[1];
        }
        return '';
      },
      /**
       * Grab the video property from a video token
       *
       * For example it will take this:
       * "{{video:https://youtube.com/embed/cXcgM8abj6g}}"
       *
       * Or this:
       * "{{video:https://www.youtube.com/embed/cXcgM8abj6g, height:3159, width:8000}}"
       *
       * and extract the "video:" property resulting in:
       * "https://www.youtube.com/embed/cXcgM8abj6g"
       *
       * @param token string - A video token string
       * @returns {string} - The video src url
       */
      getUrlFromToken: function getUrlFromToken(token) {
        var videoProperty = token.replace(/[{}]/g, '').split(',').map(function (s) {
          return s.trim();
        }).filter(function (s) {
          return s.includes('video:');
        })[0];
        var url = videoProperty.match(/.*video:(.*)/)[1];
        url = self.maybeTransformUrl(url);
        return url;
      },
      /**
       * This function will take a url and will potentially transform it
       * if it matches one of the URL structures that we've decided to
       * manually transform.
       *
       * The reason behind this is because certain providers like youtube
       * should be able to be copy/pasted from the URL, despite the fact
       * that by default those urls are not embeddable. So we'll grab the
       * video ID from the url and transform it into an embeddable URL.
       *
       * @param url string - The url to potentially be transformed
       * @returns string - Either the original url or it's embeddable equivalent
       */
      maybeTransformUrl: function maybeTransformUrl(url) {
        var serviceTransformations = [{
          // YouTube
          embedUrl: function embedUrl(id) {
            return "https://youtube.com/embed/".concat(id);
          },
          nonEmbeddableUrls: [/.*?youtube.com\/watch\?v=(.*)/, /.*?youtu.be\/(.*)/]
        }];
        var _loop = function _loop() {
            var service = _serviceTransformatio[_i2];
            var urlRef = url; // This is to avoid "referencing outer-scoped variable" warning in JSHint
            var extractedId = service.nonEmbeddableUrls.reduce(function (prev, curr) {
              var match = urlRef.match(curr);
              if (match) {
                // Grab the ID which should be the first matching group
                // and remove anything that may come after it (i.e. query params)
                // by splitting on '?' and returning first value (just the ID)
                return match[1].split('?')[0];
              } else {
                return prev;
              }
            }, null);
            return {
              v: extractedId ? service.embedUrl(extractedId) : url
            };
          },
          _ret;
        for (var _i2 = 0, _serviceTransformatio = serviceTransformations; _i2 < _serviceTransformatio.length; _i2++) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
      },
      /**
       * Takes in the displayText and replaces all iframes with {{video:...}} token replacements
       *
       * @param displayText string - The metricDisplayText from the metric report
       * @returns {string} - The mutated, token-replaced displayText
       */
      replaceIframesWithVideoTokens: function replaceIframesWithVideoTokens(displayText) {
        // Grab all iframes
        var iframes = displayText.match(/<iframe.*<\/iframe>/g);
        if (!iframes || !iframes.length) {
          return displayText;
        }

        // Build video tokens
        var videoTokens = iframes.map(function (frame) {
          var src = (frame.match(/src="(.*?)"/) || [])[1];
          var height = (frame.match(/height="(.*?)"/) || [])[1];
          var width = (frame.match(/width="(.*?)"/) || [])[1];
          return "{{video:".concat(src, ", height:").concat(height, ", width:").concat(width, "}}");
        });

        // Replace each iframe with the video token
        iframes.forEach(function (frame, index) {
          displayText = displayText.replace(frame, videoTokens[index]);
        });

        // Return modified displayText
        return displayText;
      },
      /**
       * Replace all video embed tokens with the generated video embed directives
       * This function should return the updated string. For example:
       *
       * Before: (displayText param)
       * This is a test {{video:http://youtu.be/teststring}}
       *
       * After: (returns)
       * This is a test <video-embed src="http://youtu.be/teststring" source="youtube" />
       *
       * @param displayText
       * @param videoEmbedObjects
       * @returns string - New metric display text with replacements
       */
      replaceVideoTokensWithDirectives: function replaceVideoTokensWithDirectives(displayText, videoEmbedObjects) {
        var mutatedDisplayText = displayText;
        videoEmbedObjects.forEach(function (embedObject) {
          mutatedDisplayText = mutatedDisplayText.replace(embedObject.tokenMatch, embedObject.replacement);
        });
        return mutatedDisplayText;
      },
      /**
       * Returns the un-compiled directive string with property attributes filled out & ready for compilation
       * @param url string - The src for the iframe
       * @param width {string} - Optional: Width attribute for the iframe
       * @param height {string} - Optional: Height attribute for the iframe
       * @param tokenMatch string - ex. {{video:<url>}}
       * @param service string - ex. 'youtube' | 'kaltura' | 'unknown' | etc
       *
       * *Designed to be used in an Array.map call
       * @returns { {tokenMatch: string, service: string, replacement: string} }
       */
      getTokenReplacement: function getTokenReplacement() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref.url,
          tokenMatch = _ref.tokenMatch,
          service = _ref.service,
          width = _ref.width,
          height = _ref.height;
        var replacement = '';
        if (url) {
          replacement = "<video-embed video-src=\"".concat(url, "\" service=\"").concat(service, "\" token=\"").concat(tokenMatch, "\" width=\"").concat(width, "\" height=\"").concat(height, "\"/>");
        }

        // Return new object with all the properties
        return Object.assign({}, {
          tokenMatch: tokenMatch,
          service: service,
          replacement: replacement
        });
      },
      /**
       * Grabs all the video tokens in the display text and generates video embed objects
       * which contain important information such as: url, width, height, service, etc.
       *
       * @param displayString string - The metricDisplayText passed in from the metric report
       * @returns {object[]} - The list of video embed objects reflecting the video tokens
       *                       passed in the displayString.
       */
      getVideoEmbedsFromString: function getVideoEmbedsFromString(displayString) {
        // Add a 'g' (global) flag to the matcher regexp so that we just get the patterns that match the whole pattern.
        var videoEmbedTokens = displayString.match(new RegExp(VIDEO_TOKEN_PATTERN, 'g')) || [];
        return videoEmbedTokens.map(function (token) {
          return {
            tokenMatch: token,
            url: self.getUrlFromToken(token),
            height: self.getDimension('height', token),
            width: self.getDimension('width', token)
          };
        }).map(function (videoEmbedObject) {
          // Extend the videoEmbedObject with a service property
          return Object.assign(videoEmbedObject, {
            service: self.getVideoService(videoEmbedObject.url)
          });
        }).map(self.getTokenReplacement);
      }
    };
    return self;
  }]);
})();
